"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = void 0;

var _lang = _interopRequireDefault(require("@/lang"));

var options = {
  checkOptions: function checkOptions() {
    return [// {key: "0", display_name: i18n.t("option.templateExemption")},
    {
      key: "0",
      display_name: _lang.default.t("option.templateSendOnly")
    }, {
      key: "1",
      display_name: _lang.default.t("option.manualReview")
    }, {
      key: "2",
      display_name: _lang.default.t("option.exemption")
    }];
  },
  costStatusOption: function costStatusOption() {
    return [{
      key: "0",
      display_name: _lang.default.t("option.locking")
    }, {
      key: "1",
      display_name: _lang.default.t("option.regular")
    }];
  },
  netwayCodeOption: function netwayCodeOption() {
    return [{
      key: "AliPay",
      display_name: _lang.default.t("option.alipay")
    }, {
      key: "AliPayHK",
      display_name: _lang.default.t("option.alipayHK")
    }, {
      key: "AliPayApp",
      display_name: _lang.default.t("option.alipayApp")
    }, {
      key: "AliPayAppHK",
      display_name: _lang.default.t("option.alipayAppHK")
    }, {
      key: "WeChatPay",
      display_name: _lang.default.t("option.wechat")
    }, {
      key: "WeChatPayHK",
      display_name: _lang.default.t("option.wechatHK")
    }, {
      key: "WeChatPayH5",
      display_name: _lang.default.t("option.wechatH5")
    }, {
      key: "WeChatPayH5HK",
      display_name: _lang.default.t("option.wechatH5HK")
    }, {
      key: "WeChatPayApp",
      display_name: _lang.default.t("option.wechatApp")
    }, {
      key: "WeChatPayAppHK",
      display_name: _lang.default.t("option.wechatAppHK")
    }, {
      key: "WeChatPayMiniProgram",
      display_name: _lang.default.t("option.weChatPayMiniProgram")
    }, {
      key: "WECHATPAYAPP_WeChat",
      display_name: _lang.default.t("option.wechatAppByWeChat")
    }, {
      key: "PayPalHK",
      display_name: _lang.default.t("option.paypalHK")
    }, {
      key: "PayPalUS",
      display_name: _lang.default.t("option.paypalUS")
    }, {
      key: "ApplePay",
      display_name: _lang.default.t("option.applePay")
    }, {
      key: "ApplePayCN",
      display_name: _lang.default.t("option.applePayCN")
    }, {
      key: "GooglePay",
      display_name: _lang.default.t("option.googlePay")
    }, {
      key: "SecureAcceptance",
      display_name: _lang.default.t("option.secureAcceptance")
    }, {
      key: "CyberSource",
      display_name: _lang.default.t("option.cyberSource")
    }, {
      key: "Unknown",
      display_name: _lang.default.t("common.unknownText")
    }, {
      key: "ApplePayCNTest",
      display_name: _lang.default.t("option.ApplePayCNTest")
    }, {
      key: "GooglePayTest",
      display_name: _lang.default.t("option.GooglePayTest")
    }, {
      key: "SecureAcceptanceTest",
      display_name: _lang.default.t("option.SecureAcceptanceTest")
    }, {
      key: "AlipayMiniProgramHK",
      display_name: _lang.default.t("option.AlipayMiniProgramHK")
    }, {
      key: "AlipayMiniProgramCN",
      display_name: _lang.default.t("option.AlipayMiniProgramCN")
    }];
  },
  currencyTypeOption: function currencyTypeOption() {
    return [{
      key: "HKD",
      display_name: _lang.default.t("common.HKD"),
      DollarSign: "$"
    }, {
      key: "USD",
      display_name: _lang.default.t("common.USD"),
      DollarSign: "$"
    }, {
      key: "CNY",
      display_name: _lang.default.t("common.CNY"),
      DollarSign: "¥"
    }];
  },
  rechargeTypeOption: function rechargeTypeOption() {
    return [{
      key: "agentRecharge",
      display_name: _lang.default.t("option.agentRecharge")
    }, {
      key: "payRecharge",
      display_name: _lang.default.t("option.transactionRecharge")
    }, {
      key: "platformRecharge",
      display_name: _lang.default.t("option.platformRecharge")
    }];
  },
  balanceProcessingOption: function balanceProcessingOption() {
    return [{
      key: "0",
      display_name: _lang.default.t("option.donTDealWith")
    }, {
      key: "1",
      display_name: _lang.default.t("option.transferToProcessing")
    }];
  },
  authenticateOptions: function authenticateOptions() {
    return [{
      key: "1",
      display_name: _lang.default.t("option.notApproved")
    }, {
      key: "2",
      display_name: _lang.default.t("option.approved")
    }, {
      key: "3",
      display_name: _lang.default.t("option.rejected")
    }];
  },
  statusOptions: function statusOptions() {
    return [{
      key: "0",
      display_name: _lang.default.t("option.locking")
    }, {
      key: "1",
      display_name: _lang.default.t("option.regular")
    }];
  },
  useOptions: function useOptions() {
    return [{
      key: 0,
      display_name: _lang.default.t("option.doNotUse")
    }, {
      key: 1,
      display_name: _lang.default.t("option.use")
    }];
  },
  statusOption: function statusOption() {
    return [{
      key: '0',
      display_name: _lang.default.t('option.locking')
    }, {
      key: '1',
      display_name: _lang.default.t('option.regular')
    }];
  },
  accountTypeOption: function accountTypeOption() {
    return [{
      key: '0',
      display_name: _lang.default.t('option.mainAccount')
    }, {
      key: '1',
      display_name: _lang.default.t('option.subAccount')
    }];
  },
  forceBindGoogleOption: function forceBindGoogleOption() {
    return [{
      key: "0",
      display_name: _lang.default.t("forceBindGoogleOptionText.freeText")
    }, {
      key: "1",
      display_name: _lang.default.t("forceBindGoogleOptionText.forceText")
    }];
  },
  storedGoogleStatusOption: function storedGoogleStatusOption() {
    return [{
      key: "0",
      display_name: _lang.default.t("storedGoogleStatusOptionText.noneText")
    }, {
      key: "1",
      display_name: _lang.default.t("storedGoogleStatusOptionText.storedText")
    }];
  },
  userTypeEnums: function userTypeEnums() {
    return [{
      key: "adminUser",
      display_name: _lang.default.t("common.admin")
    }, {
      key: "merchantUser",
      display_name: _lang.default.t("common.merchant")
    }, {
      key: "agentUser",
      display_name: _lang.default.t("common.agent")
    }];
  },
  numberAreaProvinceOption: function numberAreaProvinceOption() {
    return [{
      code: "1",
      name: _lang.default.t("numberAreaProvince.BeiJing"),
      areaCode: "+86"
    }, {
      code: "2",
      name: _lang.default.t("numberAreaProvince.Tianjin"),
      areaCode: "+86"
    }, {
      code: "3",
      name: _lang.default.t("numberAreaProvince.HeBei"),
      areaCode: "+86"
    }, {
      code: "4",
      name: _lang.default.t("numberAreaProvince.LiaoNing"),
      areaCode: "+86"
    }, {
      code: "5",
      name: _lang.default.t("numberAreaProvince.JiLin"),
      areaCode: "+86"
    }, {
      code: "6",
      name: _lang.default.t("numberAreaProvince.HeiLongJiang"),
      areaCode: "+86"
    }, {
      code: "7",
      name: _lang.default.t("numberAreaProvince.ShanDong"),
      areaCode: "+86"
    }, {
      code: "8",
      name: _lang.default.t("numberAreaProvince.JiangSu"),
      areaCode: "+86"
    }, {
      code: "9",
      name: _lang.default.t("numberAreaProvince.ShangHai"),
      areaCode: "+86"
    }, {
      code: "10",
      name: _lang.default.t("numberAreaProvince.ZheJiang"),
      areaCode: "+86"
    }, {
      code: "11",
      name: _lang.default.t("numberAreaProvince.AnHui"),
      areaCode: "+86"
    }, {
      code: "12",
      name: _lang.default.t("numberAreaProvince.FuJian"),
      areaCode: "+86"
    }, {
      code: "13",
      name: _lang.default.t("numberAreaProvince.JiangXi"),
      areaCode: "+86"
    }, {
      code: "14",
      name: _lang.default.t("numberAreaProvince.GuangDong"),
      areaCode: "+86"
    }, {
      code: "15",
      name: _lang.default.t("numberAreaProvince.GuangXi"),
      areaCode: "+86"
    }, {
      code: "16",
      name: _lang.default.t("numberAreaProvince.HaiNan"),
      areaCode: "+86"
    }, {
      code: "17",
      name: _lang.default.t("numberAreaProvince.HeNan"),
      areaCode: "+86"
    }, {
      code: "18",
      name: _lang.default.t("numberAreaProvince.HuNan"),
      areaCode: "+86"
    }, {
      code: "19",
      name: _lang.default.t("numberAreaProvince.HuBei"),
      areaCode: "+86"
    }, {
      code: "20",
      name: _lang.default.t("numberAreaProvince.ShanXi"),
      areaCode: "+86"
    }, {
      code: "21",
      name: _lang.default.t("numberAreaProvince.NeiMengGu"),
      areaCode: "+86"
    }, {
      code: "22",
      name: _lang.default.t("numberAreaProvince.NingXia"),
      areaCode: "+86"
    }, {
      code: "23",
      name: _lang.default.t("numberAreaProvince.QingHai"),
      areaCode: "+86"
    }, {
      code: "24",
      name: _lang.default.t("numberAreaProvince.ShanXiS"),
      areaCode: "+86"
    }, {
      code: "25",
      name: _lang.default.t("numberAreaProvince.GanSu"),
      areaCode: "+86"
    }, {
      code: "26",
      name: _lang.default.t("numberAreaProvince.XinJiang"),
      areaCode: "+86"
    }, {
      code: "27",
      name: _lang.default.t("numberAreaProvince.SiChuan"),
      areaCode: "+86"
    }, {
      code: "28",
      name: _lang.default.t("numberAreaProvince.GuiZhou"),
      areaCode: "+86"
    }, {
      code: "29",
      name: _lang.default.t("numberAreaProvince.YunNan"),
      areaCode: "+86"
    }, {
      code: "30",
      name: _lang.default.t("numberAreaProvince.ChongQing"),
      areaCode: "+86"
    }, {
      code: "31",
      name: _lang.default.t("numberAreaProvince.XiZang"),
      areaCode: "+86"
    }];
  },
  simplifiedChineseAreaOption: function simplifiedChineseAreaOption() {
    return [{
      code: "0",
      name: "中国",
      areaCode: "+86"
    }, {
      code: "1",
      name: "北京",
      areaCode: "+86"
    }, {
      code: "2",
      name: "天津",
      areaCode: "+86"
    }, {
      code: "3",
      name: "河北",
      areaCode: "+86"
    }, {
      code: "4",
      name: "辽宁",
      areaCode: "+86"
    }, {
      code: "5",
      name: "吉林",
      areaCode: "+86"
    }, {
      code: "6",
      name: "黑龙江",
      areaCode: "+86"
    }, {
      code: "7",
      name: "山东",
      areaCode: "+86"
    }, {
      code: "8",
      name: "江苏",
      areaCode: "+86"
    }, {
      code: "9",
      name: "上海",
      areaCode: "+86"
    }, {
      code: "10",
      name: "浙江",
      areaCode: "+86"
    }, {
      code: "11",
      name: "安徽",
      areaCode: "+86"
    }, {
      code: "12",
      name: "福建",
      areaCode: "+86"
    }, {
      code: "13",
      name: "江西",
      areaCode: "+86"
    }, {
      code: "14",
      name: "广东",
      areaCode: "+86"
    }, {
      code: "15",
      name: "广西",
      areaCode: "+86"
    }, {
      code: "16",
      name: "海南",
      areaCode: "+86"
    }, {
      code: "17",
      name: "河南",
      areaCode: "+86"
    }, {
      code: "18",
      name: "湖南",
      areaCode: "+86"
    }, {
      code: "19",
      name: "湖北",
      areaCode: "+86"
    }, {
      code: "20",
      name: "山西",
      areaCode: "+86"
    }, {
      code: "21",
      name: "内蒙古",
      areaCode: "+86"
    }, {
      code: "22",
      name: "宁夏",
      areaCode: "+86"
    }, {
      code: "23",
      name: "青海",
      areaCode: "+86"
    }, {
      code: "24",
      name: "陕西",
      areaCode: "+86"
    }, {
      code: "25",
      name: "甘肃",
      areaCode: "+86"
    }, {
      code: "26",
      name: "新疆",
      areaCode: "+86"
    }, {
      code: "27",
      name: "四川",
      areaCode: "+86"
    }, {
      code: "28",
      name: "贵州",
      areaCode: "+86"
    }, {
      code: "29",
      name: "云南",
      areaCode: "+86"
    }, {
      code: "30",
      name: "重庆",
      areaCode: "+86"
    }, {
      code: "31",
      name: "西藏",
      areaCode: "+86"
    }];
  },
  traditionalChineseAreaOption: function traditionalChineseAreaOption() {
    return [{
      code: "1",
      areaCode: "+852",
      name: '香港'
    }, {
      code: "2",
      areaCode: "+853",
      name: '澳门'
    }, {
      code: "3",
      areaCode: "+886",
      name: '台湾'
    }, {
      code: "4",
      areaCode: "+852",
      name: '内网'
    }];
  },
  smsTypeOption: function smsTypeOption() {
    return [{
      key: 1,
      display_name: _lang.default.t("option.SMS")
    }];
  },
  checkNumberCountOption: function checkNumberCountOption() {
    return [{
      key: "0",
      display_name: _lang.default.t("checkNumberCountOptionText.noAuditText")
    }, {
      key: "1",
      display_name: _lang.default.t("checkNumberCountOptionText.auditText")
    }];
  },
  auditOptions: function auditOptions() {
    return [{
      key: '1',
      display_name: _lang.default.t('auditOptionsText.waitForAuditText')
    }, {
      key: '2',
      display_name: _lang.default.t('auditOptionsText.auditVerifiedText')
    }, {
      key: '4',
      display_name: _lang.default.t('auditOptionsText.auditNotVerifiedText')
    }];
  },
  sendBoxAuditOptions: function sendBoxAuditOptions() {
    return [{
      key: "1",
      display_name: _lang.default.t("auditOptionsText.waitForAuditText")
    }, {
      key: "2",
      display_name: _lang.default.t("auditOptionsText.auditVerifiedText")
    }, {
      key: "4",
      display_name: _lang.default.t("auditOptionsText.auditNotVerifiedText")
    }, {
      key: '8',
      display_name: _lang.default.t('auditOptionsText.auditVerifiedText')
    }];
  },
  submitMethodOption: function submitMethodOption() {
    return [{
      key: "1",
      display_name: _lang.default.t("submitMethodOptionText.backendSubmitText")
    }, {
      key: "2",
      display_name: _lang.default.t("submitMethodOptionText.httpSubmitText")
    }, {
      key: "4",
      display_name: _lang.default.t("submitMethodOptionText.smppSubmitText")
    }];
  },
  informationOptions: function informationOptions() {
    return [{
      key: 1,
      display_name: _lang.default.t("informationOptionsText.smsMessageText")
    }];
  },
  smsNumberTypeOption: function smsNumberTypeOption() {
    return [{
      key: "1",
      display_name: _lang.default.t("smsNumberTypeOptionText.formSubmitText")
    }, {
      key: "2",
      display_name: _lang.default.t("smsNumberTypeOptionText.excelSubmitText")
    }];
  },
  searchOptions: function searchOptions() {
    return [{
      value: "0",
      label: _lang.default.t("system.userAdd.statusInput.disable")
    }, {
      value: "1",
      label: _lang.default.t("system.userAdd.statusInput.valid")
    }];
  },
  rechargeStatusOption: function rechargeStatusOption() {
    return [{
      key: "06",
      display_name: _lang.default.t("option.otherErrors")
    }, {
      key: "99",
      display_name: _lang.default.t("option.failure")
    }, {
      key: "00",
      display_name: _lang.default.t("option.success")
    }, {
      key: "04",
      display_name: _lang.default.t("option.initial")
    }, {
      key: "01",
      display_name: _lang.default.t("option.unpaid")
    }, {
      key: "03",
      display_name: _lang.default.t("option.signatureError")
    }];
  },
  bankOption: function bankOption() {
    return [{
      key: 'PSBC',
      display_name: _lang.default.t("option.PSBC")
    }, {
      key: 'SPDB',
      display_name: _lang.default.t("option.SPDB")
    }, {
      key: 'CNCB',
      display_name: _lang.default.t("option.CNCB")
    }, {
      key: 'CIB',
      display_name: _lang.default.t("option.CIB")
    }, {
      key: 'HXB',
      display_name: _lang.default.t("option.HXB")
    }, {
      key: 'CMBC',
      display_name: _lang.default.t("option.CMBC")
    }, {
      key: 'CEB',
      display_name: _lang.default.t("option.CEB")
    }, {
      key: 'CMB',
      display_name: _lang.default.t("option.CMB")
    }, {
      key: 'BCM',
      display_name: _lang.default.t("option.BCM")
    }, {
      key: 'CCB',
      display_name: _lang.default.t("option.CCB")
    }, {
      key: 'ICBC',
      display_name: _lang.default.t("option.ICBC")
    }, {
      key: 'ABC',
      display_name: _lang.default.t("option.ABC")
    }, {
      key: 'BOC',
      display_name: _lang.default.t("option.BOC")
    }];
  },
  bankAndAreaOption: function bankAndAreaOption() {
    return [{
      key: 'PSBC',
      display_name: _lang.default.t("option.PSBC")
    }, {
      key: 'SPDB',
      display_name: _lang.default.t("option.SPDB")
    }, {
      key: 'CNCB',
      display_name: _lang.default.t("option.CNCB")
    }, {
      key: 'CIB',
      display_name: _lang.default.t("option.CIB")
    }, {
      key: 'HXB',
      display_name: _lang.default.t("option.HXB")
    }, {
      key: 'CMBC',
      display_name: _lang.default.t("option.CMBC")
    }, {
      key: 'CEB',
      display_name: _lang.default.t("option.CEB")
    }, {
      key: 'CMB',
      display_name: _lang.default.t("option.CMB")
    }, {
      key: 'BCM',
      display_name: _lang.default.t("option.BCM")
    }, {
      key: 'CCB',
      display_name: _lang.default.t("option.CCB")
    }, {
      key: 'ICBC',
      display_name: _lang.default.t("option.ICBC")
    }, {
      key: 'ABC',
      display_name: _lang.default.t("option.ABC")
    }, {
      key: 'BOC',
      display_name: _lang.default.t("option.BOC")
    }, {
      key: "China",
      display_name: _lang.default.t('numberRegionOptionsText.china')
    }, {
      key: "Hong Kong",
      display_name: _lang.default.t('numberRegionOptionsText.hongKong')
    }];
  },
  remitTypeOption: function remitTypeOption() {
    return [{
      key: 'ALIPAY',
      display_name: _lang.default.t("option.alipay")
    }, {
      key: 'WECHAT',
      display_name: _lang.default.t("option.wechat")
    }, {
      key: 'BANK',
      display_name: _lang.default.t("option.onlineBanking")
    }];
  },
  remitType: function remitType() {
    return [{
      key: 'ALIPAY',
      display_name: _lang.default.t("option.alipay")
    }, {
      key: 'WECHAT',
      display_name: _lang.default.t("option.wechat")
    }, {
      key: 'BANK',
      display_name: _lang.default.t("option.onlineBanking")
    }];
  },
  approvalStatusOption: function approvalStatusOption() {
    return [{
      key: 1,
      display_name: _lang.default.t("option.pending")
    }, {
      key: 2,
      display_name: _lang.default.t("option.examinationPassed")
    }, {
      key: 4,
      display_name: _lang.default.t("option.auditNotPassed")
    }];
  },
  channelOperatorList: function channelOperatorList() {
    return [{
      key: "CTCC",
      display_name: _lang.default.t("option.CTCC")
    }, {
      key: "CMCC",
      display_name: _lang.default.t("option.CMCC")
    }, {
      key: "CUCC",
      display_name: _lang.default.t("option.CUCC")
    }];
  },
  SMSStatusOptions: function SMSStatusOptions() {
    return [{
      key: 1,
      display_name: _lang.default.t('statusOptionsText.sortingFailText')
    }, {
      key: 2,
      display_name: _lang.default.t('statusOptionsText.waitingSubmitUpstreamText')
    }, {
      key: 4,
      display_name: _lang.default.t('statusOptionsText.submitSuccessText')
    }, {
      key: 8,
      display_name: _lang.default.t('statusOptionsText.submitFailText')
    }, {
      key: 16,
      display_name: _lang.default.t('statusOptionsText.receiveSuccessText')
    }, {
      key: 32,
      display_name: _lang.default.t('statusOptionsText.receiveFailText')
    }];
  },
  protocolTypeOptions: function protocolTypeOptions() {
    return [{
      key: "http",
      display_name: _lang.default.t("smsChannelNameOptionText.httpProtocolText")
    }, {
      key: "smpp",
      display_name: _lang.default.t("smsChannelNameOptionText.smppProtocolText")
    }];
  },
  sixDealOptions: function sixDealOptions() {
    return [{
      key: 0,
      display_name: "NO"
    }, {
      key: 1,
      display_name: "YES"
    }];
  },
  smsChannelConnectionStatusOptions: function smsChannelConnectionStatusOptions() {
    return [{
      key: "1",
      display_name: _lang.default.t("smsChannelConnectionStatusOptionText.connectionSuccessText")
    }, {
      key: "2",
      display_name: _lang.default.t("smsChannelConnectionStatusOptionText.connectionFailText")
    }];
  },
  smsChannelStatusOptions: function smsChannelStatusOptions() {
    return [{
      key: "1",
      display_name: _lang.default.t("smsChannelStatusOptionText.enableText")
    }, {
      key: "2",
      display_name: _lang.default.t("smsChannelStatusOptionText.pauseText")
    }, {
      key: "4",
      display_name: _lang.default.t("smsChannelStatusOptionText.disableText")
    }];
  },
  TaskStatusOptions: function TaskStatusOptions() {
    return [{
      key: "0",
      display_name: _lang.default.t("statusOptionsText.normalText")
    }, {
      key: "1",
      display_name: _lang.default.t("statusOptionsText.pauseText")
    }];
  },
  loginBlackListRoleOptions: function loginBlackListRoleOptions() {
    return [{
      key: "1",
      name: "agent",
      display_name: _lang.default.t('loginBlackList.agentText')
    }, {
      key: "2",
      name: "organizationUser",
      display_name: _lang.default.t('loginBlackList.organizationUserText')
    }];
  },
  roleOptions: function roleOptions() {
    return [{
      key: 1,
      name: "adminUser",
      display_name: _lang.default.t('roleOptionsText.adminText')
    }, {
      key: 2,
      name: "agentUser",
      display_name: _lang.default.t('roleOptionsText.agentText')
    }, {
      key: 3,
      name: "merchantUser",
      display_name: _lang.default.t('roleOptionsText.organizationText')
    }];
  },
  searchOptionsInDictionaryManagement: function searchOptionsInDictionaryManagement() {
    return [{
      value: "Name",
      label: this.$t("system.code.initTableNameTitle")
    }, {
      value: "Code",
      label: this.$t("system.code.initTableCodeTitle")
    }, {
      value: "Parent Code",
      label: this.$t("system.code.initTableParentCodeTitle")
    }];
  },
  excelStatusOptions: function excelStatusOptions() {
    return [{
      key: 0,
      display_name: _lang.default.t("excelStatusOptionsText.availableText")
    }, {
      key: 1,
      display_name: _lang.default.t("excelStatusOptionsText.unavailableText")
    }];
  },
  exportedExcelServiceOptions: function exportedExcelServiceOptions() {
    return [// {
    //   key: "0",
    //   display_name: i18n.t("exportedExcelServiceName.sendBoxNoUseNumber")
    // },
    // {
    //   key: "1",
    //   display_name: i18n.t("exportedExcelServiceName.sendBox")
    // },
    // {
    //   key: "2",
    //   display_name: i18n.t("exportedExcelServiceName.sendRecord")
    // },
    // {
    //   key: "3",
    //   display_name: i18n.t("exportedExcelServiceName.returnRecord")
    // },
    // {
    //   key: "4",
    //   display_name: i18n.t("exportedExcelServiceName.sendBoxHistory")
    // },
    // {
    //   key: "5",
    //   display_name: i18n.t("exportedExcelServiceName.sendRecordHistory")
    // },
    // {
    //   key: "6",
    //   display_name: i18n.t("exportedExcelServiceName.returnRecordHistory")
    // },
    {
      key: "7",
      display_name: _lang.default.t("exportedExcelServiceName.statisticalAgent")
    }, {
      key: "8",
      display_name: _lang.default.t("exportedExcelServiceName.statisticalMonAgent")
    }, {
      key: "9",
      display_name: _lang.default.t("exportedExcelServiceName.statisticalChannel")
    }, {
      key: "10",
      display_name: _lang.default.t("exportedExcelServiceName.statisticalMonChannel")
    }, // {
    //   key: "11",
    //   display_name: i18n.t("exportedExcelServiceName.statisticalChannelOperator")
    // },
    // {
    //   key: "12",
    //   display_name: i18n.t("exportedExcelServiceName.statisticalMonChannelOperator")
    // },
    // {
    //   key: "13",
    //   display_name: i18n.t("exportedExcelServiceName.statisticalConsumeAmount")
    // },
    // {
    //   key: "14",
    //   display_name: i18n.t("exportedExcelServiceName.statisticalMonConsumeAmount")
    // },
    {
      key: "15",
      display_name: _lang.default.t("exportedExcelServiceName.statisticalOrgCode")
    }, {
      key: "16",
      display_name: _lang.default.t("exportedExcelServiceName.statisticalMonOrgCode")
    }];
  },
  booleanStateOption: function booleanStateOption() {
    return [{
      key: 0,
      display_name: _lang.default.t("booleanStateOptionText.noText")
    }, {
      key: 1,
      display_name: _lang.default.t("booleanStateOptionText.yesText")
    }];
  },
  activeUserOption: function activeUserOption() {
    return [{
      key: "active",
      display_name: _lang.default.t("activeUserOptionText.activeText")
    }, {
      key: "inactive",
      display_name: _lang.default.t("activeUserOptionText.inactiveText")
    }];
  },
  excelFormatOption: function excelFormatOption() {
    return [{
      key: "xls",
      display_name: _lang.default.t("excelFormatOptionText.xls")
    }, {
      key: "xlsx",
      display_name: _lang.default.t("excelFormatOptionText.xlsx")
    }];
  },
  languageOption: function languageOption() {
    return [{
      key: "zh_CN",
      name: "简体中文"
    }, {
      key: "en",
      name: "English"
    }, {
      key: "zh_TW",
      name: "繁体中文"
    }];
  },
  moneyTypeFromOption: function moneyTypeFromOption() {
    return ["USD", "CNY", "HKD", "GBP", "EUR", "QAR", "TWD", "RON", "RUB", "RWF", "DZD", "MRU"];
  },
  orderStateOption: function orderStateOption() {
    return [{
      key: 1,
      name: _lang.default.t("rechargeState.createSuccess")
    }, {
      key: 2,
      name: _lang.default.t("rechargeState.createFail")
    }, {
      key: 3,
      name: _lang.default.t("rechargeState.submitSuccess")
    }, {
      key: 4,
      name: _lang.default.t("rechargeState.submitFail")
    }, {
      key: 5,
      name: _lang.default.t("rechargeState.notifySuccess")
    }, {
      key: 6,
      name: _lang.default.t("rechargeState.notifyFail")
    }, {
      key: 7,
      name: _lang.default.t("rechargeState.refund")
    }, {
      key: 8,
      name: _lang.default.t("rechargeState.credited")
    }];
  },
  refundOrderStateOption: function refundOrderStateOption() {
    return [{
      key: 1,
      name: _lang.default.t("refundOrderState.receiveSuccess")
    }, {
      key: 2,
      name: _lang.default.t("refundOrderState.receiveFail")
    }, {
      key: 3,
      name: _lang.default.t("refundOrderState.submitSuccess")
    }, {
      key: 4,
      name: _lang.default.t("refundOrderState.submitFail")
    }, {
      key: 5,
      name: _lang.default.t("refundOrderState.refundSuccess")
    }, {
      key: 6,
      name: _lang.default.t("refundOrderState.refundFail")
    }];
  },
  currencyExchangeRateUpdateStateOptions: function currencyExchangeRateUpdateStateOptions() {
    return [{
      key: "0",
      display_name: _lang.default.t("currencyExchangeRateUpdateState.apiUpdateText")
    }, {
      key: "1",
      display_name: _lang.default.t("currencyExchangeRateUpdateState.manualUpdateText")
    }];
  },
  remitAreaType: function remitAreaType() {
    return [{
      key: "China",
      display_name: _lang.default.t('numberRegionOptionsText.china')
    }, {
      key: "Hong Kong",
      display_name: _lang.default.t('numberRegionOptionsText.hongKong')
    }];
  },
  amountChangeReasonOption: function amountChangeReasonOption() {
    return [{
      key: "PayResult",
      display_name: "支付"
    }, {
      key: "Refund",
      display_name: "退款"
    }, // {key:"Withdraw",display_name:"提现"},
    // {key:"WithdrawFail",display_name:"提现失败"},
    {
      key: "ConvertUncreditedAmount",
      display_name: "入账"
    }];
  },
  userTypeOption: function userTypeOption() {
    return [{
      key: 2,
      display_name: "代理"
    }, {
      key: 3,
      display_name: "企业"
    }];
  },
  rechargeNotifyOption: function rechargeNotifyOption() {
    return [{
      key: "1",
      display_name: _lang.default.t('notifyType.rechargeOrderNotifyText')
    }, {
      key: "2",
      display_name: _lang.default.t('notifyType.refundOrderNotifyText')
    }];
  }
};
exports.options = options;